import { useEffect, useState } from "react"
import { useEditor } from "@/utils/useEditor"

function getEditorPhysicalTransformKey(editor: ReturnType<typeof useEditor>) {
	const adjustments = editor.photo.adjustments
	return [
		editor.photo.id,
		adjustments.crop.join(","),
		adjustments.cropStraighten,
		adjustments.orientation,
		adjustments.flipX ? 1 : 0,
		adjustments.flipY ? 1 : 0,
	].join("|")
}

export function useEditorPhysicalTransformKey(currentPhotoId?: string | null) {
	const editor = useEditor()
	const [transformKey, setTransformKey] = useState(() => getEditorPhysicalTransformKey(editor))

	useEffect(() => {
		if (currentPhotoId === undefined || editor.photo.id === currentPhotoId) {
			setTransformKey(getEditorPhysicalTransformKey(editor))
		}
	}, [currentPhotoId, editor])

	useEffect(() => {
		return editor.events.subscribe((event) => {
			if (event.type === "render") {
				setTransformKey(getEditorPhysicalTransformKey(editor))
			}
		})
	}, [editor])

	if (currentPhotoId !== undefined && (!currentPhotoId || editor.photo.id !== currentPhotoId)) {
		return null
	}

	return transformKey
}
